/* 埋点接口 */
import postAnalytics from '../analytics';
import { paramsPoints } from '../encrypt';

const PUBLIC_BURY = '/public/bury';

export default {
  // 日活数据记录
  activeUser(data) {
    return postAnalytics('/active_user', paramsPoints(data));
  },
  /* 用户行为埋点 */
  behaviorPoint(sign, data) {
    return postAnalytics(`/tracks/behavior?sign=${sign}`, paramsPoints(data));
  },
  /* 进入购物车获取用户信息埋点 */
  tracksCart(data) {
    return postAnalytics('/tracks/cart', data);
  },
  /* 商品详情页视频信息埋点 */
  userAction(data) {
    return postAnalytics('/user/action', data);
  },
  /* adyen dmp */
  adyenDetainCount(data) {
    data.table = 'payment_credit_card_log';
    data.site = 1;
    data.port = 1;
    return postAnalytics(PUBLIC_BURY, data);
  },
  /* 去凑单 dmp */
  goCollect(data) {
    data.table = 'v_add_items_log';
    data.site = 1;
    data.port = 1;
    return postAnalytics(PUBLIC_BURY, data);
  },
  // 前端性能指标
  performanceDmp(data) {
    data.table = 'v_performance';
    data.site = 1;
    data.port = 1;
    data.store_id = 1;
    return postAnalytics(PUBLIC_BURY, data);
  },
  // 购物车注册按钮点击埋点
  bury(data) {
    return postAnalytics(PUBLIC_BURY, data);
  },
  // 邮件链接点击上报
  crmEdmLink(ct, store_id, email) {
    return postAnalytics(`/crm_edm_link?ct=${ct}&store_id=${store_id}&email=${email}`);
  },
  // 1007343：下单转化埋点和转化归因埋点
  conversionBury(data) {
    data.port = '1';
    return postAnalytics('/conversion/bury', data);
  },
};
